import React from 'react';

import { Button } from './button';
import { SelectMenu } from './select_menu';
import { Icon } from './icon';
import { cn } from './lib/utils';

export function Tabs({
  items = [], //{ hidden:false, key:'', title:'', icon:'' }
  active = null,
  onChange,
  className = '',
  selectOnSmallScreen = true,
}) {
  const onItemClick = (e) => {
    e.preventDefault();
    onChange(e.currentTarget.getAttribute('data-key'));
  };

  const onSelectChange = (e) => {
    onChange(e.target.value);
  };

  const renderItem = ({ hidden, key, title, icon }) => {
    if (hidden) return null;
    const activeItem = key == active;

    return (
      <Button
        key={key}
        data-key={key}
        onClick={onItemClick}
        className='relative'
        variant={activeItem ? 'secondary' : 'outline'}
        title={title}
      >
        {icon ? (
          <Icon name={activeItem ? icon + '_active' : icon} />
        ) : null}
        <span className={selectOnSmallScreen ? 'hide-on-small-body' : ''}>
          {title}
        </span>
      </Button>
    );
  };

  const renderOption = ({ hidden, key, title }) => {
    if (hidden) return null;

    return (
      <option key={key} value={key}>
        {title}
      </option>
    );
  };

  return (
    <>
      <div
        className={cn(
          'inline-flex gap-[var(--padding-small)]',
          className,
          selectOnSmallScreen && 'hide-on-small-body',
        )}
      >
        {items.map(renderItem)}
      </div>

      {selectOnSmallScreen && (
        <SelectMenu
          variant='outline'
          className='show-on-small-body'
          value={active}
          onChange={onSelectChange}
        >
          {items.map(renderOption)}
        </SelectMenu>
      )}
    </>
  );
}
